import { render, staticRenderFns } from "./CustomCoupon.vue?vue&type=template&id=355674d6&scoped=true&"
import script from "./CustomCoupon.vue?vue&type=script&lang=js&"
export * from "./CustomCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CustomCoupon.vue?vue&type=style&index=0&id=355674d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355674d6",
  null
  
)

export default component.exports